import React from "react";
import { InputBase } from "../ui/input-base";

const SocialSecurityNumberInput = React.forwardRef(
  ({ className, value, onChange, error, ...props }, ref) => {
    const handleChange = (e) => {
      const inputValue = e.target.value;
      const cleaned = inputValue.replace(/\D/g, "");
      if (cleaned.length <= 9) {
        onChange(cleaned);
      }
    };

    const formatNumber = (value) => {
      let socialSecurity = ("" + value).replace(/\D/g, "");
      const match = socialSecurity.match(/^(\d{1,3})(\d{0,2})(\d{0,4})$/);
      if (match) {
        socialSecurity = `${match[1]}${match[2] ? "-" : ""}${match[2]}${
          match[3] ? "-" : ""
        }${match[3]}`;
      }
      return socialSecurity;
    };

    return (
      <InputBase
        type="text"
        value={value ? formatNumber(value) : ""}
        onChange={handleChange}
        className={className}
        ref={ref}
        {...props}
      />
    );
  }
);
SocialSecurityNumberInput.displayName = "SocialSecurityNumberInput";

export { SocialSecurityNumberInput };
